import bootLayout from 'static/script/app/boot/boot-layout';
import ViewCheckout from 'static/script/app/ui/cart/view-cartcheckout-ui';
import CartService from 'static/script/app/data/cart-service';

export default initData => {
    bootLayout(initData);
    CartService.attachTo(document);
    ViewCheckout.attachTo('.view-checkout', { initData: initData });
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/cart-checkout.js